import BaseFormPresenter from "../../base/BaseFormPresenter";

class ProfilePagePresenter extends BaseFormPresenter {
  constructor(view, getObjectUseCase, upsertUseCase) {
    super(view, getObjectUseCase, upsertUseCase);
    this.getObjectUseCase = getObjectUseCase;
    this.upsertUseCase = upsertUseCase;
  }
}

export default ProfilePagePresenter;
